import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="login"
export default class extends Controller {
  static targets = ["form"]

  connect() {
    
  }

  async clickedLogin(event){
    event.preventDefault();
    if(!this.formTarget.checkValidity()){
      this.formTarget.classList.add("was-validated")
    }else{
      this.formTarget.submit()
    }
  }
}
